/**
 * Si la ficha se abre desde /store/products, el atrás vuelve a ese listado
 * con su búsqueda.
 */

const KEY = 'aipeces.admin.storeProducts.listSearch';
const FROM = 'aipeces.admin.storeProducts.return';

function canStore(): boolean {
    return typeof sessionStorage !== 'undefined';
}

export function rememberStoreProductsListSearch(search: string): void {
    if (!canStore()) return;
    const value = search === '' || search.startsWith('?') ? search : `?${search}`;
    sessionStorage.setItem(KEY, value);
    sessionStorage.setItem(FROM, '1');
}

export function clearStoreProductsReturn(): void {
    if (!canStore()) return;
    sessionStorage.removeItem(FROM);
}

export function storeProductsListHref(): string | null {
    if (!canStore() || sessionStorage.getItem(FROM) !== '1') return null;
    const search = sessionStorage.getItem(KEY) ?? '';
    if (!search) return '/store/products';
    return `/store/products${search.startsWith('?') ? search : `?${search}`}`;
}

export function storeProductsListHrefFrom(state: unknown): string | null {
    if (state && typeof state === 'object' && 'productsListSearch' in state) {
        const search = (state as { productsListSearch?: unknown }).productsListSearch;
        if (typeof search === 'string') {
            if (!search) return '/store/products';
            return `/store/products${search.startsWith('?') ? search : `?${search}`}`;
        }
    }
    return storeProductsListHref();
}
